import GovBanner from './GovBanner'

export default GovBanner
